import React from 'react';
import {ScrollBlocker} from "../misc/blockers/scroll-blocker";
import classNames from "classnames";
import styles from "./interstitial-ad.module.scss";
import {AdInterstitialComposer} from "./ad-interstitial.composer";
import {InterstitialAdContent} from "./interstitial-ad.content";

export const InterstitialAd = AdInterstitialComposer(({controller, isVisible, onCloseClick, unitConfig, isFilled}) => {
  const {device} = controller;
  const {isSmallView} = device;

  const blockerProps = {
    blanket: true,
    blockScrolling: true,
    disableClick: true,
    blockScrollToTop: true
  }

  const contentProps = {
    controller,
    onCloseClick,
    unitConfig,
    isFilled
  }

  return (
    isVisible ? <div className={classNames(styles.container)}>
      {
        isFilled ? <ScrollBlocker {...blockerProps}/> : null
      }
      <div className={classNames({[styles.ad_window]: isFilled, [styles.small_view]: isSmallView})}>
        <InterstitialAdContent {...contentProps}/>
      </div>
    </div> : null
  )
});